import {
  Input,
  booleanOptions,
  MultiSearchForm,
  useDebouncedSearch,
  paymentTypeOptions,
} from "@";
import {
  searchValues,
  orderStatusOptions,
  orderTypeOptions,
} from "../utils/options";

const MultiSearch = ({ onSubmit, search, updateSearch, onReset }) => {
  useDebouncedSearch(onSubmit, search.values, searchValues);

  const handleInputChange = (field, value) => {
    updateSearch({
      values: { ...search.values, [field]: value },
    });
  };

  const handleReset = () => {
    if (onReset) {
      onReset();
    } else {
      updateSearch({ values: searchValues });
    }
  };

  return (
    <MultiSearchForm
      show={search.show}
      onSubmit={onSubmit}
      className="multi-search-form grid-cols-2 xl:grid-cols-4"
      reset={handleReset}
    >
      <Input
        change={(e) => handleInputChange("id", e.target.value)}
        value={search.values.id}
        label="بحث برقم العملية"
        star
      />

      <Input
        change={(e) => handleInputChange("clientId", e.target.value)}
        value={search.values.clientId}
        label="بحث برقم العميل"
        star
      />

      <Input
        star
        label="رقم الجوال"
        value={search.values.phoneNumber}
        change={(e) => handleInputChange("phoneNumber", e.target.value)}
      />
      <Input
        star
        label="وسيلة الدفع"
        type="select"
        list={paymentTypeOptions}
        value={search.values.paymentType}
        change={(e) => handleInputChange("paymentType", e.target.value)}
      />
      <Input
        star
        label=" حالة الطلب"
        type="select"
        list={orderStatusOptions}
        value={search.values.orderStatus}
        change={(e) => handleInputChange("orderStatus", e.target.value)}
      />
      <Input
        star
        noEmptyOption
        label=" مصدر الطلب"
        type="select"
        list={orderTypeOptions}
        value={search.values.orderType}
        change={(e) => handleInputChange("orderType", e.target.value)}
      />
      <Input
        star
        label="مكتملة الدفع"
        type="select"
        list={booleanOptions}
        value={search.values.isPaid}
        change={(e) => handleInputChange("isPaid", e.target.value)}
      />
      <Input
        star
        type="number-range"
        labelA="المبلغ من"
        labelB="المبلغ الي"
        valueA={search.values.fromAmount}
        valueB={search.values.toAmount}
        changeA={(e) => handleInputChange("fromAmount", e.target.value)}
        changeB={(e) => handleInputChange("toAmount", e.target.value)}
      />
      <Input
        star
        showTimeSelect
        type="date-range"
        labelA="من تاريخ"
        labelB="الي تاريخ"
        style="xl:col-span-2"
        valueB={search.values.toDate}
        valueA={search.values.fromDate}
        changeA={(e) => handleInputChange("fromDate", e)}
        changeB={(e) => handleInputChange("toDate", e)}
      />
    </MultiSearchForm>
  );
};

export default MultiSearch;
